import { infer as Infer, z } from 'zod';

/**
 * Manual grading of a regular (non-quiz) assignment submission. The teacher
 * enters a percentage; the resulting grade value (a mapped label or the raw
 * percentage) is derived from the assignment's gradeMapping at submit time.
 */
export const assignmentGradeFormSchema = z.object({
  percentage: z
    .number('Wynik procentowy jest wymagany')
    .int('Wynik procentowy musi być liczbą całkowitą')
    .min(0, 'Wynik procentowy nie może być mniejszy niż 0')
    .max(100, 'Wynik procentowy nie może być większy niż 100'),
  desc: z.string().max(200, 'Komentarz jest zbyt długi (max 200 znaków)').optional(),
});

export type AssignmentGradeFormSchema = Infer<typeof assignmentGradeFormSchema>;
